import type {ComponentProps} from 'react'

import {NavLink} from '../../router'

type NavLinkWithoutActiveClassNameProps = ComponentProps<typeof NavLink> & {
  activeClassName?: string
  ref?: React.Ref<HTMLAnchorElement>
}

export function NavLinkWithoutActiveClassName({
  ref: forwardedRef,
  activeClassName,
  ...props
}: NavLinkWithoutActiveClassNameProps) {
  return <NavLink {...props} ref={forwardedRef} />
}

try{ NavLinkWithoutActiveClassName.displayName ||= 'NavLinkWithoutActiveClassName' } catch {}